import { CSSObject, useTheme } from '@core-ui/react-stitch';

const getCategoryNavStyles = ({ isMobileStyle }: { isMobileStyle: boolean }): CSSObject => ({
  'height': 'auto',
  'overflow': 'hidden',
  'display': 'block',
  ...(isMobileStyle && { margin: 'auto' }),
  ...(!isMobileStyle && { borderBottom: `1px solid ${useTheme().color.gray20}` }),

  'ul': {
    width: '204px',
    ...(isMobileStyle && { margin: 'auto', padding: '0' })
  },

  'ul > li': {
    padding: `${isMobileStyle ? '0.75rem 0' : '0.375rem 0'}`,
    textAlign: `${isMobileStyle ? 'center' : 'left'}`
  }
});

export default getCategoryNavStyles;
